import { createActions } from 'redux-actions';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  USER: {
    DETACH_BUSINESS_ADMIN: undefined,
    API: {
      DETACH_BUSINESS_ADMIN: apiResourceActionCreator('user')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.post(`${API_ENDPOINT}/detach-business-admin`, authToken, {}, actions.user.api.detachBusinessAdmin)

const configuration = {
  name: 'detachBusinessAdmin',
  action: actions,
  sagas: undefined,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      currentUser: Object.assign(state.currentUser, action.payload.user),
      isFetching: false,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isFetching: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/detachBusinessAdmin.js